<template>
  <AdminInputDatetime :timestamp="timestamp" @update="updateHandler" />
</template>

<script>
import { Model } from '@vuex-orm/core'
import { localToUtc, utcToLocal } from '@/utils/utcConverter'

import AdminInputDatetime from '@/components/AdminInputDatetime'
export default {
  name: 'AdminCellDatetime',
  components: {
    AdminInputDatetime,
  },
  inject: {
    cancel: { default: null },
    open: { default: null },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    Model: {
      type: Model,
      require: true,
      default: () => Model,
    },
    fieldName: {
      type: String,
      require: true,
    },
    id: {
      type: [String, Number],
      require: true,
    },
  },
  data() {
    return {
      timestamp: utcToLocal(this.value),
    }
  },
  methods: {
    save() {
      if ('function' === typeof this.Model.updateModel) {
        const fields = { [this.fieldName]: localToUtc(this.timestamp) }
        this.Model.updateModel(this.id, fields)
      }
    }, // save
    updateHandler(timestamp) {
      this.timestamp = timestamp
      this.save()
    }, // updateHandler
  },
  watch: {
    value(value) {
      this.timestamp = utcToLocal(value)
    },
  },
}
</script>
